import React from "react";
import { useParams } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CMSViewLayer from "../components/CMSManagement/CMSViewLayer";

const CMSViewPage = () => {
  const { id } = useParams();

  return (
    <MasterLayout>
      <Breadcrumb title="View CMS" />
      <CMSViewLayer id={id} />
    </MasterLayout>
  );
};

export default CMSViewPage;
